import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as api from './api'

export const getAll = createAsyncThunk('eDespatchAdvicesList/GET_ALL', async (tableState, thunkAPI) => {
  const { data, error } = await api.getAll(tableState)
  if (error) return thunkAPI.rejectWithValue(error)
  return data
})

const initialState = {
  list: [],
  totalSize: 0,
  isListLoading: false,
  error: null,
}

export const slice = createSlice({
  name: 'eDespatchAdvicesList',
  initialState,
  reducers: {
    clearList: state => {
      state.list = []
      state.totalSize = 0
      state.error = null
    },
  },
  extraReducers: builder =>
    builder
      .addCase(getAll.pending, state => {
        state.isListLoading = true
        state.error = null
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.isListLoading = false
        state.list = action.payload.data
        state.totalSize = action.payload.totalCount
      })
      .addCase(getAll.rejected, (state, action) => {
        state.isListLoading = false
        state.error = action.payload || action.error
      }),
})

export const { clearList } = slice.actions

export const listSelector = state => state.eDespatchAdvicesList.list
export const totalSizeSelector = state => state.eDespatchAdvicesList.totalSize
export const isListLoadingSelector = state => state.eDespatchAdvicesList.isListLoading
export const errorSelector = state => state.eDespatchAdvicesList.error

export const reducer = slice.reducer
